export default {
  downloadapp: {
    get_app: "GET THE APP",

    title1: "Simple Way to Order",
    title2: "Your Food",
    faster: "Faster",

    desc:
      "Manage your food procurement seamlessly with real-time pricing, verified suppliers, and reliable deliveries, all from one app.",

    text:
      "From first-time users to growing business owners, the MAHAL mobile app empowers you to manage orders, connect with verified partners, and track transactions in real-time, all from your smartphone.",

    download_on: "Download on",
    app_store: "App Store",

    get_it_on: "Get it on",
    play_store: "Play Store",
  },
};